import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import { FileText, ArrowRight } from "lucide-react";
import api from "@/lib/api";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";

export default function PortalProposals() {
  const { data: proposals = [] } = useQuery({ queryKey: ["portal-proposals"], queryFn: async () => (await api.get("/portal/proposals")).data });

  return (
    <div>
      <h1 className="font-display text-2xl font-bold">Proposals</h1>
      <p className="text-sm text-muted-foreground">Your quotes and proposals from Buddy Solution.</p>
      <div className="mt-6 space-y-3">
        {proposals.length === 0 && (
          <div className="rounded-xl border border-dashed border-border p-10 text-center">
            <FileText className="mx-auto h-8 w-8 text-muted-foreground" />
            <p className="mt-3 text-sm text-muted-foreground">No proposals yet.</p>
            <Button asChild className="mt-4 rounded-full"><Link to="/advertising">Build a quote</Link></Button>
          </div>
        )}
        {proposals.map((p) => (
          <Link key={p.id} to={`/proposal/${p.id}`} className="flex items-center justify-between bs-card p-5 hover:shadow-soft" data-testid={`portal-proposal-${p.id}`}>
            <div>
              <div className="flex items-center gap-2"><span className="font-mono text-xs text-muted-foreground">{p.proposal_no}</span><Badge variant="outline">{p.package_name}</Badge></div>
              <h3 className="mt-1 font-display font-bold">{p.currency} {Number(p.total).toLocaleString()}</h3>
            </div>
            <div className="flex items-center gap-3"><Badge variant="secondary">{p.status}</Badge><ArrowRight className="h-4 w-4 text-muted-foreground" /></div>
          </Link>
        ))}
      </div>
    </div>
  );
}
